/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Limit} from '../models/Limit';

export interface GetUserUsedLimits$Request {
    userId: number;
}

export interface GetUserUsedLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserUsedLimitsRequest = createAction<PayloadData<void, GetUserUsedLimits$Request>>('GET_USER_USED_LIMITS__GET_USER_USED_LIMITS__REQUEST');
export const getUserUsedLimitsSuccess = createAction<PayloadData<Array<Limit>, GetUserUsedLimits$Request>>('GET_USER_USED_LIMITS__GET_USER_USED_LIMITS__SUCCESS');
export const getUserUsedLimitsFailure = createAction<PayloadData<Error, GetUserUsedLimits$Request, true>>('GET_USER_USED_LIMITS__GET_USER_USED_LIMITS__FAILURE');

export const getUserUsedLimitsActions = [
    getUserUsedLimitsRequest,
    getUserUsedLimitsSuccess,
    getUserUsedLimitsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserUsedLimits = (meta: GetUserUsedLimits$Request, config?: GetUserUsedLimits$Config) => {
    return {
        CALL_API: {
            types: getUserUsedLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/used-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

